import { Link, useNavigate } from "react-router-dom";
import { CreditCard, LogOut, Settings } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-white/80 border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-3">
        <Logo to={user?.role === "admin" ? "/admin" : "/dashboard"} />
        <div className="flex items-center gap-3">
          <div className="hidden sm:block text-right leading-tight">
            <p className="text-sm font-semibold text-[#1A2B25]" data-testid="header-user-name">{user?.name}</p>
            <p className="text-xs text-[#778580]">{user?.role === "admin" ? "Super admin" : user?.email}</p>
          </div>
          {user?.role === "business" && (
            <Link to="/dashboard?view=billing" className="btn-secondary !px-3" data-testid="header-billing-link" aria-label="Billing">
              <CreditCard className="w-4 h-4" /><span className="hidden sm:inline">Billing</span>
            </Link>
          )}
          {user?.role === "business" && (
            <Link to="/account" className="btn-secondary !px-3" data-testid="header-account-link" aria-label="Account settings">
              <Settings className="w-4 h-4" /><span className="hidden sm:inline">Account</span>
            </Link>
          )}
          <button
            data-testid="logout-button"
            onClick={() => { logout(); navigate("/login"); }}
            className="btn-secondary !px-3"
            aria-label="Log out"
          >
            <LogOut className="w-4 h-4" /><span className="hidden sm:inline">Log out</span>
          </button>
        </div>
      </div>
    </header>
  );
};
